import React from "react";
import { Button, Modal } from "reactstrap";
import { FormattedMessage } from "react-intl";

type Props = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  currentStatus: boolean;
};

export default function CarrierIntegrationIsEnabledModel({ isOpen, onConfirm, onCancel, currentStatus }: Props) {
  return (
    <Modal isOpen={isOpen} className="modal-dialog-centered">
      <div className="modal-content p-3">
        {/* Modal Header */}
        <div className="modal-header pb-1">
          <h6 className="modal-title">
            <FormattedMessage id="confirm.action" defaultMessage="Confirm action" />
          </h6>
          <button type="button" className="close" onClick={onCancel}>
            <span>&times;</span>
          </button>
        </div>

        {/* Modal Body */}
        <div className="modal-body pt-2">
          <p>
            {currentStatus ? (            
                <FormattedMessage id={"carrierIntegration.isdisabled.message"} />                
            ) : (
                <FormattedMessage id={"carrierIntegration.isenabled.message"} />               

            )}
          </p>
        </div>

        {/* Modal Footer Buttons */}
        <div className="d-flex justify-content-end px-3 pb-3">
          <Button color="link" onClick={onCancel}>
            <FormattedMessage id="confirmationModal.cancelButton" />
          </Button>
          <Button color="primary" onClick={onConfirm}>
            <FormattedMessage id = "carrerIntegration.saveenable.button" />
          </Button>
        </div>
      </div>
    </Modal>
  );
}
